import { RotateCcw, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { adminApi } from '../../hooks/useAdminAi';

const fmt = (d) => new Date(d).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

export default function HelpOverrides({ overrides, reload, setMsg }) {
  const restore = async (o) => {
    const q = o.has_default ? `Restore /help/${o.slug} to its original text?` : `Remove the page /help/${o.slug}?`;
    if (!window.confirm(q)) return;
    try {
      const r = await adminApi(`/help-overrides/${o.slug}/restore`, { method: 'POST' });
      setMsg(`/help/${o.slug}: ${r.result}.`);
      await reload();
    } catch (e) { setMsg(e.message); }
  };
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4" data-testid="admin-ai-help-overrides">
      <h3 className="font-bold text-white mb-1">Published help changes</h3>
      <p className="text-xs text-zinc-500 mb-3">Pages you've approved. Restore puts the original wording back; pages you created can be removed.</p>
      {overrides.length === 0 && <p className="text-xs text-zinc-500">All help pages are on their original text.</p>}
      <div className="divide-y divide-zinc-800">
        {overrides.map((o) => (
          <div key={o.slug} className="flex items-center gap-3 py-2 text-sm" data-testid={`help-override-${o.slug}`}>
            <Link to={`/help/${o.slug}`} className="text-zinc-200 hover:text-[#00D26A] truncate flex-1">{o.title} <span className="font-mono text-xs text-zinc-500">/help/{o.slug}</span></Link>
            <span className="text-xs text-zinc-500 shrink-0">{o.updated_at ? fmt(o.updated_at) : ''}</span>
            <button onClick={() => restore(o)} className="flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold border border-zinc-700 text-[#FFD700] hover:bg-zinc-800 shrink-0" data-testid={`help-override-restore-${o.slug}`}>
              {o.has_default ? <><RotateCcw className="w-3 h-3" />Restore original</> : <><Trash2 className="w-3 h-3" />Remove page</>}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
